import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Today,
  People,
  OpenInNew,
  EventAvailable,
  GroupAdd,
  LocalHospital,
  SpeakerNotes,
  Assessment,
  Mail,
  PhotoAlbum,
  MoreVert,
  Payment,
  TrackChanges,
} from '@material-ui/icons';
import {
  Badge,
  Drawer,
  List,
  ListItem,
  Link,
  IconButton,
  Menu,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { fetchAllNotifications } from '../../services/api';
import Backgroundscroll from '../../Backgroundscroll';

const HOMEPAGE = process.env.REACT_APP_HOMEPAGE_URL;

const NavigationList = ({
  classes,
  numNotifications,
  onChoose,
  isProvider,
}) => (
  <List onClick={onChoose}>
    <ListItem button classes={{ root: classes.listItem }}>
      <NavLink
        to="/admin/schedule"
        className={classes.link}
        activeClassName={classes.activeLink}
      >
        <Today classes={{ root: classes.drawerIcon }} />
        My Calendar
      </NavLink>
    </ListItem>

    <ListItem button classes={{ root: classes.listItem }}>
      <NavLink
        to="/admin/patients"
        className={classes.link}
        activeClassName={classes.activeLink}
      >
        <People classes={{ root: classes.drawerIcon }} />
        My Patients
      </NavLink>
    </ListItem>

    <ListItem button classes={{ root: classes.listItem }}>
      <NavLink
        to="/admin/notifications"
        className={classes.link}
        activeClassName={classes.activeLink}
      >
        <Badge badgeContent={numNotifications} color="secondary">
          <Mail classes={{ root: classes.drawerIcon }} />
        </Badge>
        My Notifications
      </NavLink>
    </ListItem>

    <ListItem button classes={{ root: classes.listItem }}>
      <NavLink
        to="/admin/consult-notes"
        className={classes.link}
        activeClassName={classes.activeLink}
      >
        <SpeakerNotes classes={{ root: classes.drawerIcon }} />
        Doc to Doc Messages and Referrals
      </NavLink>
    </ListItem>

    <ListItem button classes={{ root: classes.listItem }}>
      <NavLink
        to="/admin/referrals"
        className={classes.link}
        activeClassName={classes.activeLink}
      >
        <GroupAdd classes={{ root: classes.drawerIcon }} />
        Patient Appointment Requests
      </NavLink>
    </ListItem>

    <ListItem button classes={{ root: classes.listItem }}>
      <NavLink
        to="/admin/appointments"
        className={classes.link}
        activeClassName={classes.activeLink}
      >
        <EventAvailable classes={{ root: classes.drawerIcon }} />
        My Booked Appointments
      </NavLink>
    </ListItem>


    <ListItem button classes={{ root: classes.listItem }}>
      <NavLink
        to="/admin/practices"
        className={classes.link}
        activeClassName={classes.activeLink}
      >
        <LocalHospital classes={{ root: classes.drawerIcon }} />
        My Practice
      </NavLink>
    </ListItem>

    {isProvider && (
      <>
        <ListItem button classes={{ root: classes.listItem }}>
          <NavLink
            to="/admin/provider-profile"
            className={classes.link}
            activeClassName={classes.activeLink}
          >
            <PhotoAlbum classes={{ root: classes.photoAlbum }} />
            My Provider Profile
          </NavLink>
        </ListItem>

        {/* <ListItem button classes={{ root: classes.listItem }}>
          <Link
            href="https://subscriptions.zoho.com/portal/qwell/login"
            target="_blank"
            rel="noopener"
            className={classes.link}
          >
            <Payment classes={{ root: classes.drawerIcon }} />
            My Billing (Zoho)
          </Link>
        </ListItem> */}
      </>
    )}

    <ListItem button classes={{ root: classes.listItem }}>
      <NavLink
        to="/admin/tracking-list"
        className={classes.link}
        activeClassName={classes.activeLink}
      >
        <TrackChanges classes={{ root: classes.drawerIcon }} />
        Patient Tracking List
      </NavLink>
    </ListItem>

    <ListItem button classes={{ root: classes.listItem }}>
      <NavLink
        to="/admin/activity-report"
        className={classes.link}
        activeClassName={classes.activeLink}
      >
        <Assessment classes={{ root: classes.drawerIcon }} />
        Activity Report
      </NavLink>
    </ListItem>

   
    {isProvider && (
      <>
        {/* <ListItem button classes={{ root: classes.listItem }}>
          <Link
            href="https://subscriptions.zoho.com/portal/qwell/login"
            target="_blank"
            rel="noopener"
            className={classes.link}
          >
            <Payment classes={{ root: classes.drawerIcon }} />
            My Billing (Zoho)
          </Link>
        </ListItem> */}
      </>
    )}

    <ListItem button classes={{ root: classes.listItem }}>
      <Link
        href={HOMEPAGE}
        target="_blank"
        rel="noopener"
        className={classes.link}
      >
        <OpenInNew classes={{ root: classes.drawerIcon }} />
        Qwell
      </Link>
    </ListItem>
  </List>
);

const AdminNavigation = props => {
  const {
    currentUser,
    classes: { root, drawerPaper, moreButton },
  } = props;
  const [numNotifications, setNumNotifications] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [windowWidth, setWindowWidth] = React.useState(0);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    if (window) {
      handleResize();
      window.addEventListener('resize', handleResize);
    }

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    (async () => {
      const notifications = await fetchAllNotifications();
      setNumNotifications(
        notifications.filter(notification => {
          return !notification[notification.joinType].archivedById;
        }).length
      );
    })();
  }, []);

  return windowWidth > 959 ? (
    <div>
      <div id="menu-bar">
        <Drawer
          variant="permanent"
          anchor="left"
          classes={{ root, paper: drawerPaper }}
        >
          <NavigationList
            classes={props.classes}
            numNotifications={numNotifications}
            isProvider={currentUser.isProvider}
          />
        </Drawer>
      </div>
    </div>
  ) : (
    <div>
      <IconButton
        style={{ zIndex: 100, margin: '5px', backgroundColor: '#ffffff' }}
        className={moreButton}
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVert />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        <NavigationList
          onChoose={handleClose}
          classes={props.classes}
          numNotifications={numNotifications}
          isProvider={currentUser.isProvider}
        />
      </Menu>
    </div>
  );
};

const styles = theme => ({
  moreButton: {
    position: 'fixed',
    left: 0,
    bottom: 0,
  },
  root: {
    width: '255px',
    height: '100%',
    float: 'left',
    marginTop: '75px',
    paddingTop: '10px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: '442px',
      textAlign: 'center',
      borderRight: 'none',
    },
  },
  drawerPaper: {
    width: '255px',
    height: '100%',
    backgroundColor: '#F8F8F8',
    marginTop: '100px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: '442px',
      textAlign: 'center',
    },
  },
  drawerIcon: {
    color: '#505D68',
    marginRight: '0.5rem',
  },
  listItem: {
    width: '100%',
    fontWeight: 500,
    fontSize: '16px',
    color: '#505D68',
    padding: 0,
    marginBottom: '15px',
  },
  link: {
    paddingTop: '16px',
    paddingBottom: '16px',
    paddingLeft: '3rem',
    width: '100%',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
  },
  activeLink: {
    backgroundColor: 'rgb(0, 0, 0, 0.08)',
  },
});
export default Backgroundscroll (withStyles(styles)(AdminNavigation));
